import { useSWRHandler } from "./useSWRHandler"
import { usePhones } from "src/hooks"

export function usePhoneHandler() {
  return useSWRHandler(usePhones)
}
